export const importFromGoogleSlidesDataSet = { cy: 'ImportMediaMenu-google-slides-btn' };
export const importFromYoutubeDataSet = { cy: 'ImportMediaMenu-youtube-btn' };
